import { loader } from 'graphql.macro'

export default async function createFeeType ({ dataLoaders, variables }) {
  const schema = loader('./createFeeType.graphql')
  const response = await dataLoaders.dispatcher.graphQLClient.request(schema, { input: variables })
  return response.createFeeType
}
